import { default as main } from './index';
import * as sc from './index';

export = Object.assign(main, { ...sc });
